// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Invoices: add/update form (.invoice-form, .ManageInvoices) and the details page
   (.invoice-details-page). Every rule is scoped under one of those roots. */

/* Used as a modal className by the task dialogs (AddTasks/UpdateTask). antd sets the modal
   width inline, hence !important. Phones are handled by design-system/responsive.css. */
.AddInvoiceModal {
  width: 100% !important;
  max-width: 800px;
  z-index: 100000 !important;
}

/* ── Invoice form: line items ─────────────────────────────── */
.ManageInvoices {
  background-color: var(--ds-surface);
  border-radius: var(--ds-radius-md);
  margin-block: var(--ds-space-1);
}

.ManageInvoices h2 {
  text-align: center;
  margin-bottom: var(--ds-space-5);
}

.ManageInvoices .items-section {
  background-color: var(--ds-surface-muted);
  padding: var(--ds-space-3);
  border-radius: var(--ds-radius-md);
  border: 1px solid var(--ds-border-soft);
}

.ManageInvoices .items-section h3 {
  text-align: start;
  margin-bottom: var(--ds-space-3);
}

/* Desktop/tablet: two rows of three fields per line */
.ManageInvoices .item-row {
  align-items: center;
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  padding-block: var(--ds-space-3);
  margin: 0 0 var(--ds-space-3) !important; /* antd Row sets inline negative margins */
}

/* Phones: one stacked card per line */
.ManageInvoices .item-card {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-xs);
  padding: var(--ds-space-3);
  margin-bottom: var(--ds-space-3);
}

.ManageInvoices .item-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-2);
}

.ManageInvoices .item-card__index {
  font-weight: 600;
  color: var(--ds-text-2);
}

.ManageInvoices .item-card__remove {
  min-width: var(--ds-touch, 44px);
  min-height: var(--ds-touch, 44px);
}

.ManageInvoices .item-card__field {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-1);
  min-width: 0;
  margin: 0;
}

.ManageInvoices .item-card__label {
  font-size: 12px;
  color: var(--ds-text-muted);
  overflow-wrap: anywhere;
}

.ManageInvoices .item-card__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--ds-space-2);
}

.ManageInvoices .item-card__foot {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--ds-space-3);
  padding-top: var(--ds-space-3);
  border-top: 1px solid var(--ds-border-soft);
}

.ManageInvoices .item-card__unit {
  flex: 1 1 50%;
  min-width: 0;
}

.ManageInvoices .item-card__total {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: end;
}

.ManageInvoices .item-card__total strong {
  font-size: 1.125rem;
  color: var(--ds-text);
  white-space: nowrap;
}

.ManageInvoices .items-totals {
  max-width: 360px;
  margin-inline-start: auto;
}

.ManageInvoices .ql-editor {
  min-height: 300px;
}

/* The finalize action wraps under the message on narrow screens */
.invoice-form .finalize-alert {
  flex-wrap: wrap;
  row-gap: var(--ds-space-2);
}

@media (max-width: 767.98px) {
  .ManageInvoices .items-section {
    padding: var(--ds-space-2);
  }

  .ManageInvoices .items-totals {
    max-width: none;
  }

  .invoice-form .finalize-alert .ant-alert-action {
    flex-basis: 100%;
    margin-inline-start: 0;
  }

  .invoice-form .finalize-alert .ant-alert-action .ant-btn {
    width: 100%;
  }
}

/* ── Invoice details (document preview) ───────────────────── */
.invoice-details-page {
  max-width: 1100px;
  margin-inline: auto;
  overflow-wrap: anywhere;
}

.invoice-details-page .invoice-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-4);
}

.invoice-details-page .invoice-container {
  max-width: 100%;
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
  padding: var(--ds-space-6);
}

.invoice-details-page .inv-logo {
  max-width: 180px;
  max-height: 80px;
}

/* The global theme floats these right, which lands on the wrong side in RTL. */
.invoice-details-page .invoice-details {
  float: none;
  text-align: end;
}

.invoice-details-page .invoice-payment-details > li {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

.invoice-details-page .invoice-payment-details > li span {
  float: none;
  text-align: end;
  min-width: 0;
}

.invoice-details-page .invoice-status {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
  margin-top: var(--ds-space-3);
}

.invoice-details-page .invoice-status h3 {
  margin: 0;
}

.invoice-details-page .invoice-status-tag {
  font-size: 14px;
  padding: 4px 10px;
}

.invoice-details-page .invoice-totals {
  width: 100%;
}

.invoice-details-page .invoice-totals th,
.invoice-details-page .invoice-totals td {
  vertical-align: middle;
}

.invoice-details-page .invoice-totals td {
  white-space: nowrap;
}

.invoice-details-page .invoice-totals h5 {
  margin: 0;
}

.invoice-details-page .invoice-items {
  margin-bottom: var(--ds-space-5);
}

@media (max-width: 767.98px) {
  .invoice-details-page .invoice-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .invoice-details-page .invoice-actions .ant-btn {
    width: 100%;
    min-height: 44px;
    white-space: normal;
    height: auto;
  }

  .invoice-details-page .invoice-container {
    padding: var(--ds-space-4);
    border-radius: var(--ds-radius-md);
  }

  .invoice-details-page .invoice-details {
    text-align: start;
  }

  .invoice-details-page .invoice-details h3 {
    font-size: 1.125rem;
  }

  .invoice-details-page .invoice-status {
    justify-content: flex-start;
  }
}

/* ── Invoice list: accounting filters (UI-5) ─────────────── */
.invoices-list .invoices-list__filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2) var(--ds-space-4);
  margin-bottom: var(--ds-space-3);
}

.invoices-list .invoices-list__type {
  flex: 0 1 280px;
  min-width: 0;
}

.invoices-list .invoices-list__ref {
  font-size: 12px;
  color: var(--ds-text-muted);
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .invoices-list .invoices-list__type {
    flex-basis: 100%;
  }
}

/* "Repeat this invoice" block of the invoice form */
.invoice-form .invoice-repeat {
  border: 1px solid var(--ds-border-soft);
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Billing/Invoices/Invoices.css"],"names":[],"mappings":"AAAA;4EAC4E;;AAE5E;wFACwF;AACxF;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,gEAAgE;AAChE;EACE,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,sDAAsD;AACtD;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,gCAAgC;EAChC,wCAAwC,EAAE,0CAA0C;AACtF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,gEAAgE;AAChE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;EAClD;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,oDAAoD;AACpD;EACE,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["/* Invoices: add/update form (.invoice-form, .ManageInvoices) and the details page\n   (.invoice-details-page). Every rule is scoped under one of those roots. */\n\n/* Used as a modal className by the task dialogs (AddTasks/UpdateTask). antd sets the modal\n   width inline, hence !important. Phones are handled by design-system/responsive.css. */\n.AddInvoiceModal {\n  width: 100% !important;\n  max-width: 800px;\n  z-index: 100000 !important;\n}\n\n/* ── Invoice form: line items ─────────────────────────────── */\n.ManageInvoices {\n  background-color: var(--ds-surface);\n  border-radius: var(--ds-radius-md);\n  margin-block: var(--ds-space-1);\n}\n\n.ManageInvoices h2 {\n  text-align: center;\n  margin-bottom: var(--ds-space-5);\n}\n\n.ManageInvoices .items-section {\n  background-color: var(--ds-surface-muted);\n  padding: var(--ds-space-3);\n  border-radius: var(--ds-radius-md);\n  border: 1px solid var(--ds-border-soft);\n}\n\n.ManageInvoices .items-section h3 {\n  text-align: start;\n  margin-bottom: var(--ds-space-3);\n}\n\n/* Desktop/tablet: two rows of three fields per line */\n.ManageInvoices .item-row {\n  align-items: center;\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  padding-block: var(--ds-space-3);\n  margin: 0 0 var(--ds-space-3) !important; /* antd Row sets inline negative margins */\n}\n\n/* Phones: one stacked card per line */\n.ManageInvoices .item-card {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-3);\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  box-shadow: var(--ds-shadow-xs);\n  padding: var(--ds-space-3);\n  margin-bottom: var(--ds-space-3);\n}\n\n.ManageInvoices .item-card__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n}\n\n.ManageInvoices .item-card__index {\n  font-weight: 600;\n  color: var(--ds-text-2);\n}\n\n.ManageInvoices .item-card__remove {\n  min-width: var(--ds-touch, 44px);\n  min-height: var(--ds-touch, 44px);\n}\n\n.ManageInvoices .item-card__field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-1);\n  min-width: 0;\n  margin: 0;\n}\n\n.ManageInvoices .item-card__label {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n  overflow-wrap: anywhere;\n}\n\n.ManageInvoices .item-card__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--ds-space-2);\n}\n\n.ManageInvoices .item-card__foot {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: var(--ds-space-3);\n  padding-top: var(--ds-space-3);\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n.ManageInvoices .item-card__unit {\n  flex: 1 1 50%;\n  min-width: 0;\n}\n\n.ManageInvoices .item-card__total {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  text-align: end;\n}\n\n.ManageInvoices .item-card__total strong {\n  font-size: 1.125rem;\n  color: var(--ds-text);\n  white-space: nowrap;\n}\n\n.ManageInvoices .items-totals {\n  max-width: 360px;\n  margin-inline-start: auto;\n}\n\n.ManageInvoices .ql-editor {\n  min-height: 300px;\n}\n\n/* The finalize action wraps under the message on narrow screens */\n.invoice-form .finalize-alert {\n  flex-wrap: wrap;\n  row-gap: var(--ds-space-2);\n}\n\n@media (max-width: 767.98px) {\n  .ManageInvoices .items-section {\n    padding: var(--ds-space-2);\n  }\n\n  .ManageInvoices .items-totals {\n    max-width: none;\n  }\n\n  .invoice-form .finalize-alert .ant-alert-action {\n    flex-basis: 100%;\n    margin-inline-start: 0;\n  }\n\n  .invoice-form .finalize-alert .ant-alert-action .ant-btn {\n    width: 100%;\n  }\n}\n\n/* ── Invoice details (document preview) ───────────────────── */\n.invoice-details-page {\n  max-width: 1100px;\n  margin-inline: auto;\n  overflow-wrap: anywhere;\n}\n\n.invoice-details-page .invoice-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-4);\n}\n\n.invoice-details-page .invoice-container {\n  max-width: 100%;\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n  padding: var(--ds-space-6);\n}\n\n.invoice-details-page .inv-logo {\n  max-width: 180px;\n  max-height: 80px;\n}\n\n/* The global theme floats these right, which lands on the wrong side in RTL. */\n.invoice-details-page .invoice-details {\n  float: none;\n  text-align: end;\n}\n\n.invoice-details-page .invoice-payment-details > li {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n.invoice-details-page .invoice-payment-details > li span {\n  float: none;\n  text-align: end;\n  min-width: 0;\n}\n\n.invoice-details-page .invoice-status {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n  margin-top: var(--ds-space-3);\n}\n\n.invoice-details-page .invoice-status h3 {\n  margin: 0;\n}\n\n.invoice-details-page .invoice-status-tag {\n  font-size: 14px;\n  padding: 4px 10px;\n}\n\n.invoice-details-page .invoice-totals {\n  width: 100%;\n}\n\n.invoice-details-page .invoice-totals th,\n.invoice-details-page .invoice-totals td {\n  vertical-align: middle;\n}\n\n.invoice-details-page .invoice-totals td {\n  white-space: nowrap;\n}\n\n.invoice-details-page .invoice-totals h5 {\n  margin: 0;\n}\n\n.invoice-details-page .invoice-items {\n  margin-bottom: var(--ds-space-5);\n}\n\n@media (max-width: 767.98px) {\n  .invoice-details-page .invoice-actions {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .invoice-details-page .invoice-actions .ant-btn {\n    width: 100%;\n    min-height: 44px;\n    white-space: normal;\n    height: auto;\n  }\n\n  .invoice-details-page .invoice-container {\n    padding: var(--ds-space-4);\n    border-radius: var(--ds-radius-md);\n  }\n\n  .invoice-details-page .invoice-details {\n    text-align: start;\n  }\n\n  .invoice-details-page .invoice-details h3 {\n    font-size: 1.125rem;\n  }\n\n  .invoice-details-page .invoice-status {\n    justify-content: flex-start;\n  }\n}\n\n/* ── Invoice list: accounting filters (UI-5) ─────────────── */\n.invoices-list .invoices-list__filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2) var(--ds-space-4);\n  margin-bottom: var(--ds-space-3);\n}\n\n.invoices-list .invoices-list__type {\n  flex: 0 1 280px;\n  min-width: 0;\n}\n\n.invoices-list .invoices-list__ref {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 767.98px) {\n  .invoices-list .invoices-list__type {\n    flex-basis: 100%;\n  }\n}\n\n/* \"Repeat this invoice\" block of the invoice form */\n.invoice-form .invoice-repeat {\n  border: 1px solid var(--ds-border-soft);\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
